import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import act from '~/modules/master/redux/actions/setting'

const useSetting = () => {
  const data = useSelector((state) => get(state, 'master.setting'))

  const dispatch = useDispatch()
  const actions = useMemo(() => bindActionCreators(act, dispatch), [dispatch])
  return {
    actions,
    data,
  }
}

export default useSetting
